import script from "./AudioPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts&setup=true"

import "./AudioPlayer.vue?vue&type=style&index=0&id=52f7d9ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f7d9ae"]])

export default __exports__